import { type Control, useWatch } from 'react-hook-form';
import { Stack, Grid, Typography, Box, Divider } from '@mui/material';
import UpgradeIcon from '@mui/icons-material/Upgrade';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';

import { isNil } from '#packages/data-collection/libs/lodash';

export type UpgradesDetailsProps = {
  control: Control<EditAuditFormBackgroundData>;
};

export const UpgradesDetails = ({ control }: UpgradesDetailsProps) => {
  const {
    general: {
      recentUpgrades,
      noGoProjects,
      plansForUpgrades,
      energyOpportunities,
    } = {},
  } = useWatch({ control });

  const items = [
    { label: 'Recent upgrades', value: recentUpgrades ? 'Yes' : undefined },
    { label: 'No-go projects', value: noGoProjects ? 'Yes' : undefined },
    {
      label: 'Plans for upgrades',
      value: plansForUpgrades ? 'Yes' : undefined,
    },
    {
      label: 'Energy opportunities',
      value: energyOpportunities ? 'Yes' : undefined,
    },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          sx={{ mb: 0.5 }}>
          <Grid container alignItems="center">
            <UpgradeIcon fontSize="inherit" />
            <span>&nbsp;Upgrades</span>
          </Grid>
        </Typography>
        {items.map(({ label, value }) => (
          <Grid key={label} container justifyContent="space-between">
            <Typography component="span" variant="body2">
              {label}:
            </Typography>
            <Typography
              component="span"
              variant="body2"
              color={isNil(value) ? 'textDisabled' : 'textPrimary'}>
              {value ?? '—'}
            </Typography>
          </Grid>
        ))}
        <Divider />
      </Stack>
    </Box>
  );
};
